import { useQuery } from '@tanstack/react-query';
import { fetchIncomingTransactionTracing } from '@/api/transactions';

export const incomingTracingKeys = {
  detail: (txId: string) => ['fiber-incoming-tracing', txId] as const,
};

export function useIncomingTransactionTracing(txId: string) {
  return useQuery({
    queryKey: incomingTracingKeys.detail(txId),
    queryFn: () => fetchIncomingTransactionTracing(txId),
    staleTime: 60_000,
    retry: false,
  });
}
